import axios from "axios";
import { USER_SETTINGS_UPDATE_FAIL, USER_SETTINGS_UPDATE_REQUEST, USER_SETTINGS_UPDATE_SUCCESS } from "../../constants/AttributeSettings";

export const dealerFetchSettingsAction = (token) => async (dispatch) => {
    try {
      dispatch({ type: "SETTINGS_REQUEST" });
      
    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_DP_API}/api/dealer-protal/usersettings/getsettings`,
        config
      );      
      dispatch({ type: "SETTINGS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({ type: "SETTINGS_FAIL", payload: error.message });
    }
  };

  export const dealerChangeUserSettings = (token,newSettings) => async (dispatch, getState) => {
    try {
      dispatch({ type: USER_SETTINGS_UPDATE_REQUEST });
  
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      
      const { data } = await axios.post(`${process.env.REACT_APP_DP_API}/api/dealer-protal/usersettings//update-usersettings`, newSettings, config);

      dispatch({
        type: USER_SETTINGS_UPDATE_SUCCESS,
        payload: data,
      });
      dispatch(dealerFetchSettingsAction(token));

    } catch (error) {
      dispatch({
        type: USER_SETTINGS_UPDATE_FAIL,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
    }
  };